import { render, staticRenderFns } from "./BaseFrontOfficeAlert.vue?vue&type=template&id=22fa41b0&scoped=true"
import script from "./BaseFrontOfficeAlert.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeAlert.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeAlert.vue?vue&type=style&index=0&id=22fa41b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa41b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
